export const constants = { 
    setting_github_org: 'github-org',
    setting_github_installation_id: 'github-installation-id',
    setting_github_number_of_seats: 'github-numberofseats',
}
